export function getNavigationTopOffsetProperty(navigationType) {
    return parseInt(document.documentElement.style.getPropertyValue(`--${navigationType}-top-offset-for-sticky-elements-below-navigation`), 10);
}
export function setNavigationTopOffsetProperty(navigationType, height) {
    document.documentElement.style.setProperty(`--${navigationType}-top-offset-for-sticky-elements-below-navigation`, `${height}px`);
}
export function updateNavigationTopOffsetPropertyOnResize(navigationType, element) {
    const updateNavigationTopOffsetProperty = () => setNavigationTopOffsetProperty(navigationType, element.getBoundingClientRect().height);
    updateNavigationTopOffsetProperty();
    window.addEventListener('resize', updateNavigationTopOffsetProperty);
    return () => window.removeEventListener('resize', updateNavigationTopOffsetProperty);
}
